import PropTypes from 'prop-types';

import Content from './Content';
import List from './List';

import { CtfRichTextTag } from '@/utils/constants';

export default function RichText({
  nodeType,
  content,
  invert,
  isBlockquote,
  isBlockquoteBodyLarge,
  richTextStyle,
  isDiv,
  entries = [],
}) {
  // single content
  if (
    nodeType === CtfRichTextTag.PARAGRAPH ||
    nodeType === CtfRichTextTag.HEADING_1 ||
    nodeType === CtfRichTextTag.HEADING_2 ||
    nodeType === CtfRichTextTag.HEADING_3 ||
    nodeType === CtfRichTextTag.HEADING_4 ||
    nodeType === CtfRichTextTag.HEADING_5 ||
    nodeType === CtfRichTextTag.HEADING_6 ||
    nodeType === CtfRichTextTag.BLOCKQUOTE ||
    nodeType === CtfRichTextTag.HR
  ) {
    return (
      <Content
        contents={content}
        nodeType={nodeType}
        invert={invert}
        isBlockquote={isBlockquote || isBlockquoteBodyLarge}
        isBlockquoteBodyLarge={isBlockquoteBodyLarge}
        style={richTextStyle.paragraph}
        entries={entries}
        isDiv={isDiv}
      />
    );
  }

  // list
  if (nodeType === CtfRichTextTag.UL || nodeType === CtfRichTextTag.OL)
    return (
      <List
        contents={content}
        nodeType={nodeType}
        style={richTextStyle.list}
        entries={entries}
      />
    );

  // not mapped
  return <p>{nodeType}</p>;
}

RichText.propTypes = {
  content: PropTypes.array,
  invert: PropTypes.bool,
  isBlockquote: PropTypes.bool,
  isBlockquoteBodyLarge: PropTypes.bool,
  nodeType: PropTypes.string,
  richTextStyle: PropTypes.shape({
    list: PropTypes.shape({
      li: PropTypes.string,
      ul: PropTypes.string,
      ol: PropTypes.string,
      paragraph: PropTypes.shape({
        blockquoteFont: PropTypes.string,
        customFont: PropTypes.string,
        paragraphWrapper: PropTypes.string,
      }),
    }),
    paragraph: PropTypes.shape({
      blockquoteFont: PropTypes.string,
      customFont: PropTypes.string,
      paragraphWrapper: PropTypes.string,
    }),
  }),
};

RichText.defaultProps = {
  richTextStyle: {
    list: {},
    paragraph: {},
  },
};
